module.exports = __webpack_public_path__ + "img/MatschCheck.73987dc6.svg";